import React, { forwardRef } from 'react';
import { useDispatch } from 'react-redux';

import { authActions } from 'app-components/flux/auth';
import { preferencesActions } from 'app-components/flux/preferences';

import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ToggleButton from '@mui/material/ToggleButton';
import type { ToolbarProps } from '@mui/material/Toolbar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import ToggleButtonGroupAnimated from 'components/ToggleButtonGroupAnimated';

import quickenLogo from 'assets/logos/quicken-logo.svg';
import useQPreferences from 'components/QPreferences/useQPreferences';

const DemoModeBar = forwardRef<HTMLDivElement, ToolbarProps>((_props, ref) => {
  const { datasetPreferences } = useQPreferences();
  const themeKey = datasetPreferences?.theme;
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Toolbar
      ref={ref}
      variant='dense'
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        backgroundImage: `linear-gradient(to right, ${theme.palette.action.selected}, ${theme.palette.background.paper})`,
      }}
    >
      <Box display='flex' alignItems='center' gap={2}>
        <img height={32} src={quickenLogo} alt='Quicken Simplifi' />
        LIVE DEMO MODE
        <Divider orientation='vertical' flexItem />
        <Button onClick={() => dispatch(authActions.authLogout({ reason: 'AUTH_LOGOUT_DEMO_USER' }))}>
          <ExitToAppIcon />
          Exit
        </Button>
      </Box>

      <Box display='flex' alignItems='center' gap={2}>
        <ToggleButtonGroupAnimated
          size='small'
          exclusive
          value={themeKey}
          onChange={(_event, value) => {
            dispatch(
              preferencesActions.setPreferenceSuccess({
                section: 'shared',
                group: 'dataset',
                preference: {
                  webApp: {
                    theme: value === 'ACME_DARK' ? 'ACME_DARK' : 'simplifiDefault',
                  },
                },
              }),
            );
          }}
        >
          <ToggleButton value={'simplifiDefault'}>
            <LightModeOutlinedIcon />
          </ToggleButton>
          <ToggleButton value={'ACME_DARK'}>
            <DarkModeOutlinedIcon />
          </ToggleButton>
        </ToggleButtonGroupAnimated>
        Ready to purchase?
        <a href='https://www.quicken.com/products/pricing-comparison/#pricing'>
          <Button variant='contained'>Get Started</Button>
        </a>
      </Box>
    </Toolbar>
  );
});

DemoModeBar.displayName = 'DemoModeBar';
export default DemoModeBar;
